import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Chipbar element, used to wrap chips
 *
 * @slot - Unnamed slot (default slot)
 *
 */
let SDBChipBar = class SDBChipBar extends LitElement {
    render() {
        return html ` <slot></slot> `;
    }
};
SDBChipBar.styles = [
    elements,
    css `
            :host {
                position: relative;
                display: flex;
                justify-content: left;
                align-items: center;
                flex-wrap: wrap;
            }
        `,
];
SDBChipBar = __decorate([
    customElement('sdb-content-chipbar')
], SDBChipBar);
export { SDBChipBar };
//# sourceMappingURL=sdb-content-chipbar.js.map